import { render } from "./FbCheckboxGroupField.vue?vue&type=template&id=c2eed74a"
import script from "./FbCheckboxGroupField.vue?vue&type=script&lang=js"
export * from "./FbCheckboxGroupField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__